export default {"src":"/_next/static/media/feed-the-obesession-animation.74783dd8.svg","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};